"use client";

import { useState, useEffect } from "react";
import { Modal, Button, message } from "antd";
import { Form } from "react-bootstrap";
import { CloseOutlined, DeleteOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";
import {
  addsymptom,
  deletesymptom,
  updatesymptom,
} from "../../services/doctor/symptom/symptom";
import {
  addFinding,
  deleteFinding,
  updateFinding,
} from "../../services/doctor/findings/findings";
import {
  addDiagnoses,
  deleteDiagnoses,
  updateDiagnoses,
} from "../../services/doctor/diagnoses/diagnoses";
import {
  addInvestigation,
  deleteInvestigation,
  updateInvestigation,
} from "../../services/doctor/investigation/investigation";
import {
  addProcedure,
  deleteProcedure,
  updateProcedure,
} from "../../services/doctor/procedure/procedure";
import {
  addInstruction,
  deleteInstruction,
  updateInstruction,
} from "../../services/doctor/instruction/instruction";
import { useAuth } from "../../services/authentication_API/authService";

export default function AddModal({
  show,
  name_iteam,
  onHide,
  refresh,
  type,
  isedit,
  data,
}) {
  console.log("name",name_iteam)
  const [name, setName] = useState( "");
  const [error, setError] = useState("");
  const [messageApi, contextHolder] = message.useMessage();
  const [selectedOption, setSelectedOption] = useState("");
  const {userData}=useAuth();
  console.log("data",type,data)

useEffect(() => {
    // Logic for Edit Mode (Prioritize data.name)
    if (isedit && data?.name) {
      setName(data.name);
      setSelectedOption(data?.type || "");
    } 
    // Logic for Add Mode (Use name_iteam)
    else if (!isedit && name_iteam) {
      setName(name_iteam);
      setSelectedOption(""); // Clear any previous type selection
    } 
    // Fallback/Reset when hiding or switching context
    else {
      setName("");
      setSelectedOption("");
    }
  // Ensure we listen to changes in isedit, data, AND name_iteam
  }, [isedit, data, name_iteam]);

  const validateForm = () => {
    if (!name.trim()) {
      setError("Name is required");
      return false;
    }
    setError("");
    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    const formData = { name:name, doctor_id:userData?.id };
    let result;

    try {
      switch (type) {
        case "Symptoms" :
        case "symptoms":
          if (isedit) {
            result = await updatesymptom(data.id, {...formData,  _method: "put"});
          } else {
            result = await addsymptom(formData);
          }
          break;

        case "Findings":
        case "findings":
          if (isedit) {
            result = await updateFinding(data.id, formData);
          } else {
            result = await addFinding(formData);
          }
          break;
        case "Diagnosis":
        case "diagnosis":
          if (isedit) {
            result = await updateDiagnoses(data.id, formData);
          } else {
            result = await addDiagnoses(formData);
          }
          break;

        case "Investigations":
        case "investigations":
          if (isedit) {
            result = await updateInvestigation(data.id, {
              ...formData,
              type: selectedOption,
            });
          } else {
            result = await addInvestigation({
              ...formData,
              type: selectedOption,
            });
          }

          break;
        case "Procedures":
        case "procedures":
          if (isedit) {
            result = await updateProcedure(data.id, formData);
          } else {
            result = await addProcedure(formData);
          }
          break;
        case "Instructions":
        case "instructions":
          if (isedit) {
            result = await updateInstruction(data.id, formData);
          } else {
            result = await addInstruction(formData);
          }
          break;
        default:
          messageApi.error("Invalid type");
          return;
      }

      if (result?.success) {
        messageApi.open({
          type: "success",
          content: isedit
            ? `${type} updated successfully!`
            : `${type} added successfully!`,
        });

        onHide(result?.data);
        refresh(type);
      } else {
         let errorMsg = "Something went wrong";

        if (typeof result?.error === "string") {
          errorMsg = result.error;
        } else if (typeof result?.error === "object") {
          const key = Object.keys(result.error)[0];
          errorMsg = result.error[key][0];
        }

        messageApi.error(errorMsg);
      }
    } catch (error) {
      messageApi.error(error.message || "Submission failed");
      console.error("catch error:", error);
    }
  };
   const handleDelete = async () => {
    if (!validateForm()) return;

    const formData = { name:name, doctor_id:userData?.id };
    let result;

    try {
      switch (type) {
        case "Symptoms" :
        case "symptoms":
            result = await deletesymptom(data.id);
          
          break;

        case "Findings":
        case "findings":
            result = await deleteFinding(data.id);
          break;
        case "Diagnosis":
        case "diagnosis":
            result = await deleteDiagnoses(data.id);
          break;

        case "Investigations":
        case "investigations":
            result = await deleteInvestigation(data.id);

          break;
        case "Procedures":
        case "procedures":
            result = await deleteProcedure(data.id);
          break;
        case "Instructions":
        case "instructions":
            result = await deleteInstruction(data.id);
          break;
        default:
          messageApi.error("Invalid type");
          return;
      }

      if (result?.success) {
        messageApi.open({
          type: "success",
          content:  `${type} deleted successfully!`
        });

        onHide(result?.data);
        refresh(type);
      } else {
         let errorMsg = "Something went wrong";

        if (typeof result?.error === "string") {
          errorMsg = result.error;
        } else if (typeof result?.error === "object") {
          const key = Object.keys(result.error)[0];
          errorMsg = result.error[key][0];
        }

        messageApi.error(errorMsg);
      }
    } catch (error) {
      messageApi.error(error.message || "Submission failed");
      console.error("catch error:", error);
    }
  };

  return (
    <>
      {contextHolder}
      <Modal
        title={isedit ? `Edit ${type}` : `Add ${type}`}
        open={show}
        onCancel={()=>onHide(null)}
        centered
        keyboard={false}
        maskClosable={false} 
        footer={[
         isedit && (
        <Button 
            key="delete" 
            icon={
                <DeleteOutlined 
                    style={{ 
                        fontSize: '150%', // You can adjust this size
                    }}
                />
            }  
            style={{ color: "#ff4d4f" }} 
            onClick={() => { 
                onHide(null); 
                handleDelete();
            }}
        />
    ),
          <Button key="cancel" onClick={()=>onHide(null)}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleSubmit}>
            {isedit ? "Update" : "Add"}
          </Button>,
        ]}
        width={800}
        className="vitals-modal"
        closeIcon={<CloseOutlined />}
      >
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              placeholder={`Enter ${type} name`}
              value={name}
              onChange={(e) => setName(e.target.value)}
              isInvalid={!!error}
            />
            <Form.Control.Feedback type="invalid">
              {error}
            </Form.Control.Feedback>
          </Form.Group>
          {(type === "Investigations" || type === "investigations") && (
            <Form.Group className="mb-3">
              <Form.Label>Type</Form.Label>
              <div className="d-flex gap-2 flex-wrap">
                {/* Common style for button & input */}
                {["Imaging", "Radiology", "Pathology"].map((option) => (
                  <Button
                    key={option}
                    variant={
                      selectedOption === option ? "primary" : "outline-primary"
                    }
                    onClick={() => setSelectedOption(option)}
                    active={selectedOption === option}
                    style={{
                      width: "180px",
                      height: "38px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: selectedOption === option ? "#f0f7ff" : "white",
                      borderColor:
                        selectedOption === option ? "#1890ff" : "#d9d9d9",
                      color: selectedOption === option ? "#1890ff" : "inherit",
                    }}
                  >
                    {option}
                  </Button>
                ))}

                {/* Custom input field */}
                <Form.Control
                  type="text"
                  placeholder="Custom"
                  value={
                    ["Imaging", "Radiology", "Pathology"].includes(
                      selectedOption
                    )
                      ? ""
                      : selectedOption
                  }
                  onChange={(e) => setSelectedOption(e.target.value)}
                  style={{
                    width: "180px",
                    height: "38px",
                  }}
                />
              </div>
            </Form.Group>
          )}
        </Form>
      </Modal>
    </>
  );
}

AddModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  refresh: PropTypes.func,
  type: PropTypes.string.isRequired,
  isedit: PropTypes.bool,
  data: PropTypes.object,
  name_iteam: PropTypes.string
};

AddModal.defaultProps = {
  isedit: false,
};
